<div class="form-page">
  <div class="form-page-chess" aria-hidden="true"></div>
  <div class="form-page-image" aria-hidden="true"></div>

  <div class="form-page-frame">
    <div class="form-page-row">
      <div class="form-page-visual">
        <div class="form-page-visual-stack">
          <img
            class="form-page-visual-logo"
            src="assets/images/login-logo.svg"
            alt="A Square ERP Solutions"
            width="234"
            height="48"
          />
          <div class="form-page-visual-copy-block">
            <div class="form-page-visual-copy" [attr.aria-live]="'polite'">
              <h2>{{ brandingSlides[activeSlide].title }}</h2>
              <p>{{ brandingSlides[activeSlide].body }}</p>
            </div>
            <div class="form-page-visual-dots" role="tablist" aria-label="Feature highlights">
              @for (slide of brandingSlides; track $index) {
                <button
                  type="button"
                  role="tab"
                  class="form-page-visual-dot"
                  [class.is-active]="activeSlide === $index"
                  [attr.aria-selected]="activeSlide === $index"
                  [attr.aria-label]="'Show slide ' + ($index + 1)"
                  (click)="setActiveSlide($index)"
                  (mouseenter)="onDotHover($index)"
                  (focus)="onDotHover($index)"
                ></button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-page-panel">
        @if (subscriberLoginGroup) {
          <form class="login-form figma-auth-form" [formGroup]="subscriberLoginGroup" (ngSubmit)="Userlogin()">
            <div class="login-form-main">
              <div class="login-form-content">
                <div class="login-heading">
                  <h3>Welcome back.</h3>
                  <p>Let's simplify your business today.</p>
                </div>

                <div class="login-fields-block">
                  <div class="login-fields-cluster">
                    <div class="login-input-stack">
                      <div class="field-item">
                        <label for="subscriber-username">Username*</label>
                        <div class="figma-input">
                          <span class="figma-input__leading-icon" aria-hidden="true">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="7.99967" cy="4.00004" r="2.66667" stroke="currentColor" stroke-width="1.3" />
                              <path d="M13.3337 11.6666C13.3337 13.3235 13.3337 14.6666 8.00033 14.6666C2.66699 14.6666 2.66699 13.3235 2.66699 11.6666C2.66699 10.0098 5.05481 8.66663 8.00033 8.66663C10.9458 8.66663 13.3337 10.0098 13.3337 11.6666Z" stroke="currentColor" stroke-width="1.3" />
                            </svg>
                          </span>
                          <input
                            type="email"
                            class="figma-input-field"
                            id="subscriber-username"
                            placeholder="Enter Username"
                            formControlName="Username"
                            autocomplete="username"
                            data-initial-focus
                          />
                        </div>
                        @if (subscriberLoginGroup.get('Username')?.invalid && subscriberLoginGroup.get('Username')?.touched) {
                          <small class="field-error">{{ getErrorMessage() }}</small>
                        }
                      </div>

                      <div class="field-item">
                        <label for="subscriber-password">Password*</label>
                        <div class="figma-input">
                          <span class="figma-input__leading-icon" aria-hidden="true">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_subscriber_lock)">
                                <path d="M1.33301 10.6666C1.33301 8.78101 1.33301 7.8382 1.91879 7.25241C2.50458 6.66663 3.44739 6.66663 5.33301 6.66663H10.6663C12.552 6.66663 13.4948 6.66663 14.0806 7.25241C14.6663 7.8382 14.6663 8.78101 14.6663 10.6666C14.6663 12.5522 14.6663 13.4951 14.0806 14.0808C13.4948 14.6666 12.552 14.6666 10.6663 14.6666H5.33301C3.44739 14.6666 2.50458 14.6666 1.91879 14.0808C1.33301 13.4951 1.33301 12.5522 1.33301 10.6666Z" stroke="currentColor" stroke-width="1.3" />
                                <path d="M4 6.66671V5.33337C4 3.12424 5.79086 1.33337 8 1.33337C10.2091 1.33337 12 3.12424 12 5.33337V6.66671" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_subscriber_lock">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <input
                            [type]="hide ? 'password' : 'text'"
                            class="figma-input-field"
                            id="subscriber-password"
                            placeholder="Enter Password"
                            formControlName="Password"
                            autocomplete="current-password"
                          />
                          <button type="button" class="figma-input-toggle" (click)="hide = !hide" [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
                            <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="login-options">
                      <label class="remember-me">
                        <input type="checkbox" class="remember-me-toggle" formControlName="rememberMe" />
                        <span class="remember-me-switch-wrap" aria-hidden="true">
                          <span class="remember-me-switch">
                            <svg class="remember-me-switch__svg remember-me-switch__svg--off" width="36" height="20" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path class="remember-me-switch__track" d="M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10C36 15.5228 31.5228 20 26 20H10C4.47715 20 0 15.5228 0 10Z" fill="#D5D7DA" />
                              <path class="remember-me-switch__knob" d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z" fill="white" />
                            </svg>
                            <svg class="remember-me-switch__svg remember-me-switch__svg--on" width="36" height="20" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path class="remember-me-switch__track" d="M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10C36 15.5228 31.5228 20 26 20H10C4.47715 20 0 15.5228 0 10Z" fill="#0076FE" />
                              <path class="remember-me-switch__knob" d="M19 10C19 6.13401 22.134 3 26 3C29.866 3 33 6.13401 33 10C33 13.866 29.866 17 26 17C22.134 17 19 13.866 19 10Z" fill="white" />
                            </svg>
                          </span>
                        </span>
                        <span class="remember-me-label">Remember me</span>
                      </label>
                      <a class="forgot-password-link" (click)="redirectToForgotPassword()">Forgot password?</a>
                    </div>
                  </div>

                  @if (!(runtimeConfigService.isLocalNetwork$ | async) && !(runtimeConfigService.isElectron$ | async)) {
                    <div class="login-captcha">
                      <ngx-recaptcha2
                        #captchaElem
                        [siteKey]="CaptchaSiteKey"
                        [size]="size"
                        [hl]="lang"
                        [theme]="theme"
                        [type]="type"
                        (success)="handleSuccess($event)"
                      />
                    </div>
                  }

                  <button
                    class="login-submit-btn"
                    [class.login-submit-btn--loading]="isLoading"
                    type="submit"
                    [disabled]="isLoading"
                    [attr.aria-busy]="isLoading"
                  >
                    @if (isLoading) {
                      <span class="gradient-loader" aria-hidden="true"></span>
                    } @else {
                      <span class="login-submit-btn-label">Login</span>
                    }
                  </button>
                  @if (InvalidLogin) {
                    <p class="login-status-text">Invalid email or password</p>
                  }
                  @if (ErrorMessage) {
                    <p class="login-status-text">{{ ErrorMessage }}</p>
                  }

                  <p class="login-signup-footer">
                    Not registered yet?
                    <a (click)="redirectToSignup()">Create an Account</a>
                  </p>
                </div>
              </div>

              <div class="login-or">
                <span></span>
                <p>OR</p>
                <span></span>
              </div>

              <button type="button" class="login-google-btn" (click)="onGoogleSignInClick()">
                <svg class="login-google-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M22.5015 12.2332C22.5015 11.3699 22.43 10.7399 22.2753 10.0865H12.2158V13.9832H18.1205C18.0015 14.9515 17.3587 16.4099 15.9301 17.3898L15.91 17.5203L19.0907 19.935L19.311 19.9565C21.3348 18.1249 22.5015 15.4298 22.5015 12.2332Z" fill="#4285F4"/>
                  <path d="M12.215 22.5C15.1078 22.5 17.5363 21.5666 19.3102 19.9566L15.9292 17.3898C15.0245 18.0082 13.8102 18.4399 12.215 18.4399C9.38167 18.4399 6.97693 16.6082 6.11971 14.0765L5.99406 14.087L2.68681 16.5954L2.64355 16.7132C4.40543 20.1432 8.02448 22.5 12.215 22.5Z" fill="#34A853"/>
                  <path d="M6.11997 14.0766C5.89379 13.4233 5.76289 12.7232 5.76289 11.9999C5.76289 11.2765 5.89379 10.5766 6.10807 9.92325L6.10208 9.78411L2.75337 7.23547L2.64381 7.28655C1.91765 8.7099 1.50098 10.3083 1.50098 11.9999C1.50098 13.6916 1.91765 15.2899 2.64381 16.7132L6.11997 14.0766Z" fill="#FBBC05"/>
                  <path d="M12.215 5.55997C14.2269 5.55997 15.584 6.41163 16.3579 7.12335L19.3817 4.23C17.5246 2.53834 15.1078 1.5 12.215 1.5C8.02451 1.5 4.40544 3.85665 2.64355 7.28662L6.10783 9.92332C6.97696 7.39166 9.38171 5.55997 12.215 5.55997Z" fill="#EB4335"/>
                </svg>
                <span class="login-google-label">Sign in with Google</span>
              </button>
              @if (!platform.is('capacitor')) {
                <div class="login-google-hidden" id="google-button" aria-hidden="true"></div>
              }
            </div>

            <div class="login-footer-row">
              <p class="login-copyright">© 2026 ASERP. All Rights Reserved.</p>
            </div>
          </form>
          <button type="button" class="form-page-info-btn" aria-label="Information">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </button>
        }
      </div>
    </div>
  </div>
</div>
